/* eslint-disable camelcase */
import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const SessionHandler = async () => {
  const appId = await DataHandler.matchAppId();
  const user = await StorageHandler.load(storageKeys.user);
  let intervalId;

  const clearSessionInterval = () => {
    clearInterval(intervalId);
    window.localStorage.removeItem('session');
  };

  // Start session when user is logged in (!warning, user.email or user.response.email, different per app)
  if (user) {
    // Check if a session already exists and if so, exit
    const sessionId = await StorageHandler.load(storageKeys.session);
    if (sessionId) {
      return;
    }

    const email = user.email ? user.email : user.response.email;
    const session = await APIHandler.startSession(appId, email, 'pc');

    if (session) {
      const { session_id } = session;
      await StorageHandler.save(storageKeys.session, session_id);
      window.addEventListener('clearSessionInterval', clearSessionInterval);

      // Every 5 minutes, update the session
      intervalId = setInterval(async () => {
        StorageHandler.load(storageKeys.session).then((id) => {
          APIHandler.updateSession(id);
        });
      }, 10000);
    }
  }

  // On logout and on close end session
  window.addEventListener('beforeunload', () => {
    clearInterval(intervalId);
    window.localStorage.removeItem('session');
    window.removeEventListener('clearSessionInterval', clearSessionInterval);
  });
};

export default SessionHandler;
